export default __webpack_public_path__ + "static/BW-link-cover-FR-8946bc178607e8b516d9d5d0a1ff654d.jpg";